/* eslint-disable @typescript-eslint/naming-convention */
export enum UserConsentStatusEnum {
    OPEN = '0',
    ACCEPTED = '1',
    DECLINED = '2',
    REVOKED = '3',
}
